<div class="text-center mat-padding">
  <button
    (click)="openAddOrgDialog(addOrg)"
    mat-raised-button
    color="primary"
    type="button"
  >
    {{ 'institutions.list.add' | translate }}
  </button>
</div>

<table
  *ngIf="institutions$ | async; else loading"
  mat-table
  [dataSource]="dataSource"
  class="mat-elevation-z1"
  style="width: 100%;"
>
  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.logo' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="element.logo?.length">
        <img height="30" [src]="element.logo" />
      </div>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.name' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="credits">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.still_credits' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.credits }}</td>
  </ng-container>

  <ng-container matColumnDef="total_credits">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.total_credits' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ getSumCredits(element.credits_logs) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="used_credits">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.used_credits' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.registrations?.length }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'institutions.list.actions' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Actions on the user"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          *ngFor="let action of actions; trackBy: trackByMethod"
          mat-menu-item
          (click)="action.click(element)"
        >
          <mat-icon>{{ action.icon }}</mat-icon>
          <span>{{ action.text | translate }}</span>
        </button>

        <button
          type="button"
          mat-menu-item
          (click)="openAddOrgDialog(addOrg, element)"
        >
          <mat-icon>edit</mat-icon>
          <span>
            {{ 'institutions.list.organisation_edit' | translate }}
          </span>
        </button>

        <!--
          <button
            type="button"
            mat-menu-item
            (click)="openCreditsHistory(creditsTable, element)"
          >
            <mat-icon>history</mat-icon>
            <span>Voir les attributions de licences</span>
          </button>


          <button
            type="button"
            mat-menu-item
            (click)="creditsTableComponent.openEditsCreditsDialog(element)"
          >
            <mat-icon>add</mat-icon>
            <span>Ajouter des licences</span>
          </button>
        -->

        <!--
          <button type="button" mat-menu-item (click)="creditsTableComponent.openEditsCreditsDialog(element)">
            <mat-icon>remove</mat-icon>
            <span>Retirer des licences</span>
          </button>
        -->
      </mat-menu>

      <ng-template #creditsTable>
        <div class="mat-padding">
          <polylearn-credits-table
            (update)="updateInstitutions$.next('update')"
            [creditsLog]="element.credits_logs"
          >
          </polylearn-credits-table>
        </div>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>

<ng-template #addOrg>
  <form id="editOrgForm" *ngIf="editOrgForm" [formGroup]="editOrgForm">
    <div fxLayout="column" fxLayoutGap="16px">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ 'institutions.list.organisation_name' | translate }}
        </mat-label>
        <input
          formControlName="name"
          required
          matInput
          #input
          placeholder="Ex. name"
        />
      </mat-form-field>

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'institutions.list.logo_url' | translate }}
          </mat-label>
          <input
            formControlName="logo"
            matInput
            #input
            type="text"
            placeholder="https://"
          />
          <mat-hint>Max size: 300ko</mat-hint>
        </mat-form-field>

        <div>
          <input type="file" (change)="uploadFile($event)" />
        </div>
      </div>

      <!--
        <mat-form-field appearance="outline">
          <mat-label>Nombre de licences restantes</mat-label>
          <input formControlName="credits" matInput required #input type="number" placeholder="1000">
        </mat-form-field>


      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>Durée d'une licence</mat-label>
          <mat-select formControlName="credit_duration" required>
            <mat-option
              *ngFor="let duration of availablesDuration"
              [value]="duration.value"
            >
              {{ duration.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      -->

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'institutions.list.slug' | translate }}
          </mat-label>
          <input
            formControlName="slug"
            matInput
            #input
            type="text"
            placeholder=""
          />
          <mat-hint *ngIf="getUrl() as url">{{ url }}</mat-hint>
        </mat-form-field>

        <div>
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="generateSlug()"
          >
            {{ 'institutions.list.generate' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <br />
  <div fxLayout="row" fxLayoutGap="16px">
    <button type="button" mat-button mat-dialog-close>
      {{ 'institutions.list.close' | translate }}
    </button>

    <button
      color="primary"
      [disabled]="editOrgForm.invalid"
      mat-raised-button
      type="button"
      mat-button
      [mat-dialog-close]="editOrgForm.value"
    >
      {{ 'institutions.list.validate' | translate }}
    </button>
  </div>
</ng-template>
